import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";

import { api } from "../../_services/api.service";
import { userService } from "../../_services/user.service";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import PageTitle from "../../Layout/AppMain/PageTitle";
import GeneralGrid from "../../Components/GeneralGrid";
import Loader from "react-loaders";
import { CustomInput } from "reactstrap";
import { toast } from "react-toastify";
import swal from "sweetalert";
import download from "downloadjs";
import ButtonDropdown from "reactstrap/lib/ButtonDropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";

const UserList = (props) => {
  let partnerId = props.match.params.partnerId;

  const hiddenFileInput = React.useRef(null);
  const currentUser = userService.getLoggedInUser();
  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };
  const usersExceededError =
    "You have reached the limit of users based on your subscription.  If you would like add others, please go to your account and upgrade your subscription.";

  const errorToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.ERROR,
    hideProgressBar: false,
  };
  let [isOpen, setIsOpen] = useState(false);
  let [userList, setUserList] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [partnerUsersCount, setPartnerUsersCount] = useState(0);
  let [partnerMaxUsers, setPartnerMaxUsers] = useState(-1);
  let [userUploadTemplateUrl, setUserUploadTemplateUrl] = useState("");
  const [partner, setPartner] = useState(null);
  const [columns, setColumns] = useState([]);
  const [isGeneratingSurveys, setIsGeneratingSurveys] = useState(false);
  const [isLoadingResults, setIsLoadingResults] = useState(false);

  useEffect(() => {
    if (partnerId > 0) {
      loadData(partnerId);
    }
  }, []);

  useEffect(() => {
    if (partner != undefined && partner != null) {
      setColumns([
        {
          dataField: "firstName",
          text: "Name",
          headerStyle: () => {
            return { width: "25%" };
          },
          sort: true,
          formatter: (cellContent, row) => {
            return (
              <a
                key={row.userID}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  goToDetails(row.userID);
                }}
              >
                {row.firstName + " " + row.lastName}
              </a>
            );
          },
        },

        {
          dataField: "email",
          text: "Email",
          headerStyle: () => {
            return { width: "25%" };
          },
          sort: true,
        },
        {
          dataField: "userSubscriptionStartDT",
          text: "Start Date",
          headerStyle: () => {
            return { width: "15%" };
          },
          formatter: (cellContent, row) => {
            return cellContent ? moment(cellContent).format("L") : "";
          },
        },
        {
          dataField: "scenarioCount",
          text: `# ${partner?.decisionName ?? "Decision"}`,
          headerStyle: () => {
            return { width: "10%" };
          },
          sort: true,
        },
        // {
        //   dataField: "partnerRole",
        //   text: "Role",
        //   headerStyle: () => {
        //     return { width: "10%" };
        //   },
        // },
        {
          dataField: "inactive",
          headerStyle: () => {
            return { width: "10%" };
          },
          text: "Inactive",
          sort: true,
          formatter: (cellContent, row) => {
            return (
              <CustomInput
                readOnly={true}
                type="checkbox"
                id={row.partnerID}
                checked={row.inactive}
              />
            );
          },
        },
      ]);
    }
  }, [partner]);

  const loadData = (pid) => {
    setIsLoading(true);
    api.getUsers(pid).then((data) => {
      data.forEach((x) => {
        x.isSelected = false;
      });
      setUserList(data);
      setPartnerUsersCount(data.length);

      api.getPartnerById(pid).then((p) => {
        setPartner(p);
        setPartnerMaxUsers(p.maxUsers);
        setIsLoading(false);
      });
    });
  };

  const downloadUsersExcelTemplate = (e) => {
    e && e.preventDefault();
    api.getUsersExcelTemplate().then((blob) => {
      download(blob, "UsersTemplate.xlsx");
    });
  };

  const goToDetails = (userId) => {
    props.history.push({
      pathname: `/usersettings/${partnerId}/${userId}`,
    });
  };

  const handleUploadFileClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleInputFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    event.target.value = "";

    swal({
      text: "Do you want to also send invitation emails?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then((val) => {
      api
        .uploadUsers(
          currentUser.userId,
          partnerId,
          val ? true : false,
          fileUploaded
        )
        .then(
          (data) => {
            if (data && data !== "") {
              let text = data.split(".").join("; \n");
              swal({
                text: text,
                icon: "warning",
                buttons: {
                  ok: "Ok",
                },
                dangerMode: true,
              });
            }
            loadData(partnerId);
          },
          (err) => {
            toast(`Could not upload file, ${err}`, errorToastOpts);
          }
        );
    });
  };

  const handleUserSelect = (row, isSelect) => {
    setUserList(
      userList.map((x) => {
        if (x.userID == row.userID) {
          x.isSelected = isSelect;
        }
        return x;
      })
    );
  };

  const handleUserSelectAll = (isSelect, rows) => {
    setUserList(
      userList.map((x) => {
        x.isSelected = isSelect;
        return x;
      })
    );
  };

  const resendInvitationEmails = () => {
    let users = userList.filter((x) => x.isSelected);
    if (users.length == 0) {
      swal({
        text: "No user selected.",
        icon: "warning",
      });
    } else {
      swal({
        text: `Are you sure you want to resend ${users.length} emails?`,
        buttons: {
          ok: "Yes",
          cancel: "Cancel",
        },
      }).then((val) => {
        if (val) {
          api.resendInvitationBulk(currentUser.userId, users).then(
            (data) => {
              toast(`Invitations were sent`, successToastOpts);
            },
            (err) => {
              toast(`An error occured, ${err}`, errorToastOpts);
            }
          );
        }
      });
    }
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const defaultSorted = [
    {
      dataField: "lastName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const generateSurvey = async () => {
    let tasks = userList
      .filter((x) => x.isSelected)
      .map((x) => async () => {
        return await api.generateScenarios(x.userID, partnerId, 0);
      });
    if (tasks.length > 0) {
      setIsGeneratingSurveys(true);
      await Promise.all(tasks.map((t) => t()));
      toast.success("Surveys generated");
      setIsGeneratingSurveys(false);
    }
  };

  const getSurveyResultsReport = () => {
    var userIds = userList.filter((x) => x.isSelected).map((x) => x.userID);
    if (userIds.length > 0) {
      setIsLoadingResults(true);

      api.getScenarioReportQueryParam(currentUser.userId).then((guid) => {
        api
          .getSurveyReport(currentUser.userId, partnerId, 0, guid, userIds)
          .then(
            (blob) => {
              setIsLoadingResults(false);
              download(blob, "SurveyResults.xls");
            },
            (err) => setIsLoadingResults(false)
          );
      });
    }
  };

  const archive = async () => {
    let tasks = userList
      .filter((x) => x.isSelected)
      .map((x) => async () => {
        return await api.archiveScenarios(x.userID, partnerId, 0);
      });
    if (tasks.length > 0) {
      await Promise.all(tasks.map((t) => t()));
      toast.success(`${partner?.decisionName ?? 'Decision'}s archived successfully`);
    }
  };

  return (
    <Fragment>
      <PageTitle icon="fas fa-users" heading={"Users"} />
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && columns.length > 0 && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="12">
            <Card className="main-card mb-3">
              <CardBody>
                <div>
                  Below is a list of users that are currently in your
                  organization. Adding a user to your subscription allows him or
                  her to use all the aspects of Definitive Choice AND use the
                  templates you give them access to.
                  <br />
                  <br />
                </div>
                <Col>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <ButtonDropdown isOpen={isOpen} toggle={toggle}>
                      <Button id="caret" color="primary">
                        Actions
                      </Button>
                      <DropdownToggle split color="primary" />
                      <DropdownMenu>
                        <DropdownItem onClick={() => resendInvitationEmails()}>
                          Resend Invitation Emails
                        </DropdownItem>
                        <DropdownItem
                          onClick={generateSurvey}
                          disabled={isGeneratingSurveys}
                        >
                          Generate Surveys
                        </DropdownItem>
                        <DropdownItem
                          onClick={getSurveyResultsReport}
                          disabled={isLoadingResults}
                        >
                          Survey Results
                        </DropdownItem>
                        <DropdownItem
                          onClick={archive}
                          disabled={isLoadingResults}
                        >
                          Archive {partner?.decisionName ?? 'Decision'}s
                        </DropdownItem>
                      </DropdownMenu>
                    </ButtonDropdown>
                  </div>
                </Col>
                <GeneralGrid
                  title=""
                  keyField="userID"
                  defaultSortedColumn="firstName"
                  dataSource={userList}
                  filterColumns={["firstName", "lastName"]}
                  columns={columns}
                  defaultSorted={defaultSorted}
                  options={options}
                  buttonText="Add User"
                  showAddBtn={partnerUsersCount < partnerMaxUsers}
                  errorText={
                    partnerUsersCount < partnerMaxUsers
                      ? ""
                      : usersExceededError
                  }
                  onAdd={() => goToDetails(-1)}
                  selectRow={{
                    mode: "checkbox",
                    clickToSelect: true,
                    onSelect: handleUserSelect,
                    onSelectAll: handleUserSelectAll,
                  }}
                />
                <Col>
                  <input
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    ref={hiddenFileInput}
                    onChange={handleInputFileChange}
                    style={{ display: "none" }}
                  />
                  <Button
                    color="primary"
                    style={{ marginTop: ".25rem" }}
                    onClick={handleUploadFileClick}
                  >
                    Upload File
                  </Button>
                  <br />
                  <a
                    href="#"
                    onClick={downloadUsersExcelTemplate}
                    style={{ marginLeft: ".25rem" }}
                  >
                    Download excel template
                  </a>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default UserList;
